import React, { useEffect,useState, useMemo, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { loadArchiveUsers } from '../../redux/actions/userActions';
import {
  Button,
  buttonSizes,
  buttonTypes,
  buttonTextSizes,
} from '../shared/Button';
import CardView from '../svg/CardView';
import RowView from '../svg/RowView';
import SvgXIcon from '../svg/XIcon';
import DownArrowIcon from '../svg/DownArrowIcon';
import UserListTable from './UserListTable';
import UserListCards from './UserListCards';
import {
  searchText,
  resetText,
  sortOrderText,
} from '../shared/SharedInternationalizations';
import sort from '../../utilities/sort';
import Pager from '../shared/Pager';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import permissions from '../../permissionsList';
import { loadUsers } from '../../redux/actions/userActions';
import { loadUnits } from '../../redux/actions/unitActions';
import DropdownMenu from '../shared/dropdownMenu/DropdownMenu';
import DropdownMenuItem from '../shared/dropdownMenu/DropdownMenuItem';
import SvgGear from '../svg/Gear';
import SvgCheckMarkIcon from '../svg/CheckMarkIcon';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import "../../scss/partials/users/_user-list.css"

let restoreUsersSearchFocusOnNav = false;

export function UnconnectedUserList(props) { 
 const [check,setCheck]=useState([])
 const [searchValue, setSearchValue] = useState('');
 const searchDebounce = useRef(null);
 const searchInputRef = useRef(null);
//  let selected=[];
 let tempStatus;
  const { usersArray, apiSpinner, unitsObj } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const currentLocation = location.pathname + location.search;
  const { search } = location;
  const pathname = location.pathname;
  const userStatusObj =props.userStatuses;
  const userList = useMemo(() => {
    const list = [];
    // Just Copy the usersArray into userList
    if(usersArray&&usersArray.length>0){
      usersArray.map(d=>{// eslint-disable-line
      list.push({
          account_inactive_date: d.account_inactive_date,
          active_unit: d.active_unit,
          alarm_devices:d.alarm_devices,
          alert_devices:d.alert_devices,
          assigned_device_count:d.assigned_device_count,
          checkin_profile:d.checkin_profile,
          date_joined:d.date_joined,
          date_of_birth:d.date_of_birth,
          email: d.email,
          eula:d.eula,
          first_name:d.first_name,
          gender:d.gender,
          groups: d.groups,
          id: d.id,
          is_active: d.is_active,
          is_staff: d.is_staff,
          is_superuser:d.is_superuser,
          last_login: d.last_login,
          last_name: d.last_name,
          middle_name:d.middle_name,
          modified_date: d.modified_date,
          notes: d.notes,
          password: d.password,
          password_expires: d.password_expires,
          phone: d.phone,
          photo: d.photo,
          preferences:d.preferences,
          preferred_name: d.preferred_name,
          saraprofile:d.saraprofile,
          status:d.status,
          suffix:d.suffix,
          title:d.title,
          units: d.units,
          user_permissions: d.user_permissions,
          userbuttons:d.userbuttons,
          usercategoryorders:d.usercategoryorders,
          username: d.username
      
      })
    })
    }
    return list;
  }, [usersArray]);

  // To replicate the functionality that is found elsewhere in the legacy interface of when a user navigates away from the users interface they can return to it and have it look the same as when they left,
  // the interface uses a variety of query parameters in the url to ensure that the interface display is able to be replicated.
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  // The view parameter determines if the view is the user card or table display
  let displayType = '';
  if (searchParams.get('view')) {
    displayType = searchParams.get('view');
  }

  // let startValue = 0;
  // if (searchParams.get('start')) {
  //   startValue = searchParams.get('start');
  //   console.log(startValue);

  //   setPager(startValue);
  // }

  // Sortorder is to determine if the sorting is ascending or descending with the default being descending
  let sortOrder = 'az';
  if (searchParams.get('sort')) {
    sortOrder = searchParams.get('sort');
  }

  // Param is used to determine what parameter the users should be sorted by with the default being set to last name
  let sortParam = 'last_name';
  if (searchParams.get('param')) {
    sortParam = searchParams.get('param');
  }

  // Staff determines whether staff users should be displayed with the default being that they will be displayed
  let showStaff = true;
  if (searchParams.get('staff')) {
    showStaff = searchParams.get('staff');
  }

  // Nonstaff determines whether nonstaff users should be displayed with the default being that they will be displayed
  let showNonStaff = true;
  if (searchParams.get('nonStaff')) {
    showNonStaff = searchParams.get('nonStaff');
  }

  // Active determines if active or archived users should be displayed.
  let showActive = true;
  if (searchParams.get('active')) {
    showActive = searchParams.get('active');
  }

  // Search is for the contents of the search input
  let activeFilter = '';
  if (searchParams.get('search')) {
    activeFilter = searchParams.get('search');
  } else {
    searchParams.delete('search');
  }

  // Keep the controlled input in sync with the URL search query.
  useEffect(() => {
    setSearchValue(activeFilter || '');
  }, [activeFilter]);

  useEffect(() => {
    if (restoreUsersSearchFocusOnNav && searchInputRef.current) {
      searchInputRef.current.focus();
      const cursorPosition = searchInputRef.current.value.length;
      searchInputRef.current.setSelectionRange(cursorPosition, cursorPosition);
      restoreUsersSearchFocusOnNav = false;
    }
  }, [search]);
  
  // Display is used for the pager and splits the data into three numbers that are then used by the pager to update the display
  // The first digit is the total length of the users array to be displayed
  // The second is the start value for displaying on that page
  // The third is the number of users to the incremented each time the pager is clicked.
  const display = useMemo(() => {
    let displayObj = { totalLength: 0, startValue: 0, incrementValue: 25 };
    if (searchParams.get('display')) {
      // the display parameter is a string so it's first split apart
      const displayArr = searchParams.get('display').split('-');
      // then the array created is used to create a new object. Since the individual numbers are brought in as strings
      // they need to be parsed into integers
      displayObj = {
        totalLength: parseInt(displayArr[0], 10),
        startValue: parseInt(displayArr[1], 10) || 0,
        incrementValue: parseInt(displayArr[2], 10) || 25,
      };
    }
    return displayObj;
  }, [searchParams]);

  const getFilteredUsersCount = (filterTerm) => {
    let searchedUsers = [];
    if (filterTerm !== '') {
      const filterContents = filterTerm.toUpperCase().split(' ');
      searchedUsers = userList.filter((user) => {
        let filterResult = 0;
        const userSearchText =
          user.title +
          ' ' +
          user.first_name +
          ' ' +
          user.preferred_name +
          ' ' +
          user.last_name +
          ' ' +
          user.suffix + ' ' +
          (user.username || '') + ' ' +
          (user.email || '') + ' ' +
          getUnitName(user.active_unit);

        filterContents.forEach((filterContent) => {
          if (userSearchText.toUpperCase().includes(filterContent)) {
            filterResult += 1;
          }
        });

        return filterResult === filterContents.length;
      });
    } else {
      searchedUsers = userList;
    }

    const filteredUsers = searchedUsers.filter((user) => {
      let showUser = true;
      if (showStaff === 'false' && user.is_staff) showUser = false;
      if (showNonStaff === 'false' && !user.is_staff) showUser = false;
      if (showActive === 'false' && user.is_active) showUser = false;
      if (showActive === 'true' && !user.is_active) showUser = false;
      return showUser;
    });

    return filteredUsers.length;
  };

  // Load all units and users when the component first loads
  useEffect(() => {
    props.dispatch(loadUnits());
    props.dispatch(loadUsers());
  }, []); // eslint-disable-line

  useEffect(() => {
    return () => {
      if (searchDebounce.current) {
        clearTimeout(searchDebounce.current);
      }
    };
  }, []);

useEffect(()=>{ 
  // copy the status name,and status id into the set array 
  if(props.userStatuses){
      const set = [];
      Object.values(props.userStatuses).map((val, k) =>
         set.push({
             label:val.description,
             value:val.description,
             id:val.id,
             isChecked:false,
             })
         )
         setCheck(set)     
      }
},[props.userStatuses])

  // Handle navigation for pager updates
  useEffect(() => {
    // Only update if we have users and are on the main users page
    if (userList.length > 0 && (pathname === '/users' || pathname === '/users/')) {
      const filteredUserCount = getFilteredUsersCount(activeFilter);

      // Check if the total length has changed and update the URL
      if (filteredUserCount !== display.totalLength) {
        const pagerValues = { ...display };
        pagerValues.totalLength = filteredUserCount;
        const pagerString = `${pagerValues.totalLength}-${pagerValues.startValue}-${pagerValues.incrementValue}`;
        
        const newSearchParams = new URLSearchParams(search);
        if (newSearchParams.get('display')) {
          newSearchParams.set('display', pagerString);
        } else {
          newSearchParams.append('display', pagerString);
        }
        
        navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
      }
    }
  }, [userList, activeFilter, showStaff, showNonStaff, showActive, display, pathname, search, location.pathname, navigate]);

  // This resets all the filters by resetting the url to not have any query parameters.
  function resetFilters() {
    navigate(location.pathname, { replace: true });
  }

  const archivedUsersButton = (
    <FormattedMessage
      id="userList.archivedUsersButtonText"
      defaultMessage="Display Archived Users"
      description="A button to toggle between archive and active units"
    />
  );
  const activeUsersButton = (
    <FormattedMessage
      id="userList.activeUsersButtonText"
      defaultMessage="Display Active Users"
      description="A button to toggle between archive and active units"
    />
  );

  const getUnitName = (unitId) => {
  if (!unitId || !unitsObj) return '';
  const unit = unitsObj[unitId];
  return unit ? unit.name || '' : '';
  };

  function usersDisplay() {
    // This function formats and sets the user data to display in whatever format is desired. The user data is formatted, filtered, and sorted then at the end, depending on the display type that is set, it'll send the data to the appropriate component for display.

    // The first filter is the search input. It checks to see if there's anything in that input and then filters out anything that doesn't contain that string in the user first name, last name, preferred name, title, or suffix.
    let searchedUsers = [];
    const filterValue = searchValue || activeFilter;
    if (filterValue !== '') {
      const filterContents = filterValue.toUpperCase().split(' ');
      // Make the device name uppercase for case insensitivity

    
        searchedUsers = userList.filter((user) => {
        let filterResult = 0;
        const searchText =
          user.title +
          ' ' +
          user.first_name +
          ' ' +
          user.preferred_name +
          ' ' +
          user.last_name +
          ' ' +
          user.suffix +
          ' ' +
          (user.username || '') +
          ' ' +
          (user.email || '') +
          ' ' +
          getUnitName(user.active_unit);

        filterContents.forEach((word) => {
          if (searchText.toUpperCase().includes(word)) {
            filterResult++;
          }
        });

        // this takes the number from positive filter results and checks to see if it matches the number of words in the search. If they match, it returns true
        // This way, if the user enters 2 words, first and last names, and they both match a user the filter result will be 2 so it'll return true
        if (filterResult > 0 && filterResult === filterContents.length) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      searchedUsers = userList;
    }

    // Filter based on if the staff and non-staff checkboxes are selected
    const filteredUsers = searchedUsers.filter((user) => {
    //  When the data comes from the query parameter, it is a string even though the contents are boolean, so this is checking for if it's true as a boolean but also if the string "true" is present   
      if ((showStaff === true || showStaff === 'true') && user.preferences) {
        return true;
      } else if (
        (showNonStaff === true || showNonStaff === 'true') &&
        !user.preferences
      ) {
        return true;
      }
      return '';
    });

    //filter based on the selected status 
    let  filtered;
    if(sortParam==='status_name'){
        filtered=selected.length>0?
           filteredUsers.filter(statuscode => 
             selected.some(statusid => statuscode.status === statusid.id)):filteredUsers;
       }
       else{
            filtered=filteredUsers;
        }   

    // filter based on if archived or non-archived users are selected
    const filteredArchiveUsers = filtered.filter((user) => {
      // When the data comes from the query parameter, it is a string even though the contents are boolean, so this is checking for if it's true as a boolean but also if the string "true" is present
      if ((showActive === false || showActive === 'false') && !user.is_active) {
        return true;
      } else if (
        (showActive === true || showActive === 'true') &&
        user.is_active
      ) {
        return true;
      }
      return '';
    });
 let sortedUsers=[];
 let filter=[];
//  If sort param is status_name then add the status name into the newly created array called filter
     if(sortParam==='status_name'){
       filteredArchiveUsers.map(d=>{// eslint-disable-line
         filter.push({
          account_inactive_date: d.account_inactive_date,
          active_unit: d.active_unit,
          alarm_devices:d.alarm_devices,
          alert_devices:d.alert_devices,
          assigned_device_count:d.assigned_device_count,
          checkin_profile:d.checkin_profile,
          date_joined:d.date_joined,
          date_of_birth:d.date_of_birth,
          email: d.email,
          eula:d.eula,
          first_name:d.first_name,
          gender:d.gender,
          groups: d.groups,
          id: d.id,
          is_active: d.is_active,
          is_staff: d.is_staff,
          is_superuser:d.is_superuser,
          last_login: d.last_login,
          last_name: d.last_name,
          middle_name:d.middle_name,
          modified_date: d.modified_date,
          notes: d.notes,
          password: d.password,
          password_expires: d.password_expires,
          phone: d.phone,
          photo: d.photo,
          preferences:d.preferences,
          preferred_name: d.preferred_name,
          saraprofile:d.saraprofile,
             status:d.status,
             status_name:d.status?userStatusObj[d.status].description:'',
          suffix:d.suffix,
          title:d.title,
          units: d.units,
          user_permissions: d.user_permissions,
          userbuttons:d.userbuttons,
          usercategoryorders:d.usercategoryorders,
          username: d.username
         })
       })
      //  sort according to the status name
       sortedUsers=sort(filter,sortParam,sortOrder);   
    } 
  
    else{
    // sort users based on the sort parameter and sort order defined above
     sortedUsers = sort(filteredArchiveUsers, sortParam, sortOrder);
  }
    // Check to see if the pager is needed, then set the pager information appropriately
    // (Navigation logic moved to useEffect to avoid calling navigate during render)
    // take the sorted users and only add the ones that should be displayed based on the pager settings to the pagedUsers array
    let pagedUsers = [];
    sortedUsers.map((user, index) => {
      if (
        index >= display.startValue &&
        index < display.startValue + display.incrementValue
      ) {
         pagedUsers.push(user);
      }
      return '';
    }); 
 
   // display the user data based on the selected format
    if (displayType === 'table') {
      return (
        <UserListTable
          activeFilter={activeFilter}
          usersArray={pagedUsers}
          data-test="user-list-table"
          currentLocation={currentLocation}
          apiSpinner={apiSpinner}
        />
      );
    } else {
      return (
        <UserListCards
          users={pagedUsers}
          sortParam={sortParam}
          sortOrder={sortOrder}
          activeFilter={activeFilter}
          location={location}
          data-test="user-list-cards"
          apiSpinner={apiSpinner}
        />
      );
    }
  }

  // function to set the pager to the start of the list
  function resetPager() {
    // create a new object for the pager to use for display
    const updatedPager = { ...display };
    // set the start value of the object to be 0
    updatedPager.startValue = 0;
    // create the string that is added to the query parameters for the pager
    const pagerString = `${updatedPager.totalLength}-${updatedPager.startValue}-${updatedPager.incrementValue}`;
    // check to see if the display parameter exists
    if (searchParams.get('display')) {
      // if it does, set it with the pager string
      searchParams.set('display', pagerString);
    } else {
      // if it doesn't, create it and add it to the parameters
      searchParams.append('display', pagerString);
    }
  }
// The sort parameter was used as the dropdown's title 
// As a result, the following functions are used to display the sort parameter in uppercase
  let str2;
  function load(){
    if(sortParam==='first_name'||sortParam==='last_name'){
      // in the sort param, delete the underscore and replace it with a space
        const r= sortParam.replace(/_/g, ' ')
        const arr = r.split(" ");
          for (var i = 0; i < arr.length; i++) {
             arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
            }
           str2 = arr.join(" ");    
          }
        else {
            str2='Status';
       }
      //  return title to the sorting dropdown
    return str2;
  }
  // set the sort parameter
  function changeSortParam(event) {
     let val;
    // get the key value from the drop down item
    let key= event.target.innerHTML.split('<')[0];   
       if(key==='Last Name'){
           val='last_name';  
          }
        else if(key==='First Name'){
          val='first_name';
          }
        else{
          val='status_name'; 
          }
 
    const param=val;   
  // const param = event.target.value;
    // check to see if the sort parameter query parameter exists
    if (searchParams.get('param')) {
      // if so, set it with the param string
      searchParams.set('param', param);
    } else {
      // if not, create it and add it
      searchParams.append('param', param);
    }

    // Reset checkboxes when switching away from status sorting
    if (param !== 'status_name') {
      const resetChecks = check.map(statusValues => ({
        ...statusValues,
        isChecked: false
      }));
      setCheck(resetChecks);
    }

    // set the pager back to 0 because whenever anything is changed with the sorting, apparently that's supposed to happen.
    resetPager();
    // update the url with the changed query parameters
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    }, { replace: true });
  }

  function toggleSortOrder() {
    const currentOrder = sortOrder;
    if (currentOrder === 'az') {
      // check to see if the sort order query parameter exists
      if (searchParams.get('sort')) {
        // if so, set it with the param string
        searchParams.set('sort', 'za');
      } else {
        // if not, create it and add it
        searchParams.append('sort', 'za');
      }
      // setSortOrder('za');
    } else if (currentOrder === 'za') {
      // setSortOrder('az');
      if (searchParams.get('sort')) {
        searchParams.set('sort', 'az');
      } else {
        searchParams.append('sort', 'az');
      }
    }
    // set the pager back to 0 because whenever anything is changed with the sorting, apparently that's supposed to happen.
    resetPager();
    // update the url with the changed query parameters
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    }, { replace: true });
  }

  function toggleShowStaff() {
    const currentStaff = showStaff;
    if (currentStaff === 'true' || currentStaff === true) {
      // check to see if the staff filter query parameter exists
      if (searchParams.get('staff')) {
        // if so, set it with the param string
        searchParams.set('staff', false);
      } else {
        // if not, create it and add it
        searchParams.append('staff', false);
      }
    } else if (currentStaff === 'false' || currentStaff === false) {
      if (searchParams.get('staff')) {
        searchParams.set('staff', true);
      } else {
        searchParams.append('staff', true);
      }
    }
    // set the pager back to 0 because whenever anything is changed with the sorting, apparently that's supposed to happen.
    resetPager();
    // update the url with the changed query parameters
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    }, { replace: true });
  }

  function toggleShowNonStaff() {
    const currentNonStaff = showNonStaff;
    if (currentNonStaff === true || currentNonStaff === 'true') {
      // check to see if the non-staff query parameter exists
      if (searchParams.get('nonStaff')) {
        // if so, set it with the param string
        searchParams.set('nonStaff', false);
      } else {
        // if not, create it and add it
        searchParams.append('nonStaff', false);
      }
    } else if (currentNonStaff === false || currentNonStaff === 'false') {
      if (searchParams.get('nonStaff')) {
        searchParams.set('nonStaff', true);
      } else {
        searchParams.append('nonStaff', true);
      }
    }
    // set the pager back to 0 because whenever anything is changed with the sorting, apparently that's supposed to happen.
    resetPager();
    // update the url with the changed query parameters
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    }, { replace: true });
  }

  function toggleShowArchived() {
    const currentActive = showActive;
    if (currentActive === true || currentActive === 'true') {
      props.dispatch(loadArchiveUsers());
      // check to see if the show archived query parameter exists
      if (searchParams.get('active')) {
        // if so, set it with the param string
        searchParams.set('active', false);
      } else {
        // if not, create it and add it
        searchParams.append('active', false);
      }
    } else if (currentActive === false || currentActive === 'false') {
      if (searchParams.get('active')) {
        searchParams.set('active', true);
      } else {
        searchParams.append('active', true);
      }
    }
    // set the pager back to 0 because whenever anything is changed with the sorting, apparently that's supposed to happen.
    resetPager();
    // update the url with the changed query parameters
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    }, { replace: true });
  }

  function setPager(startValue) {
    const pagerValues = { ...display };
    let start = startValue;
    if (start <= 0) {
      pagerValues.startValue = 0;
      pagerValues.endValue = display.incrementValue - 1;
    } else {
      pagerValues.startValue = start;
      pagerValues.endValue = startValue + display.incrementValue - 1;
    }
    const pagerString = `${pagerValues.totalLength}-${pagerValues.startValue}-${pagerValues.incrementValue}`;
    if (searchParams.get('display')) {
      searchParams.set('display', pagerString);
    } else {
      searchParams.append('display', pagerString);
    }
    // update the url with the changed query parameters
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    }, { replace: true });
  }

  function changeIncrementValue(event) {
    const incrementValue = parseInt(event.target.value, 10);
    const pagerValues = { ...display };

    pagerValues.incrementValue = incrementValue;
    pagerValues.endValue = display.startValue + incrementValue - 1;
    pagerValues.startValue = 0;
    const pagerString = `${pagerValues.totalLength}-${pagerValues.startValue}-${pagerValues.incrementValue}`;
    if (searchParams.get('display')) {
      searchParams.set('display', pagerString);
    } else {
      searchParams.append('display', pagerString);
    }
    // update the url with the changed query parameters
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    }, { replace: true });
  }
//  set the selected status
  const handleSelect=(e)=>{   
      const {value,checked}=e.target;
        if(value==='All'){
            tempStatus=check.map(statusValues=>{
            return {...statusValues,isChecked:checked}
          })
          setCheck(tempStatus)
      }
      else{
          tempStatus=check.map(statusValues=>
          statusValues.value===value?{...statusValues,isChecked:checked}:statusValues
          );
          setCheck(tempStatus);
          console.log('Checkbox updated:', value, 'checked:', checked, tempStatus);
         }
      
      // When any checkbox is checked, automatically set sort param to status_name
      if (checked && sortParam !== 'status_name') {
        if (searchParams.get('param')) {
          searchParams.set('param', 'status_name');
        } else {
          searchParams.append('param', 'status_name');
        }
        resetPager();
        navigate({
          pathname: location.pathname,
          search: searchParams.toString(),
        }, { replace: true });
      }
      }
    
// Build the selected array for filtering based on checked status items
const selected = [];
if (sortParam === 'status_name') {
  check.forEach(d => {
    if (d.isChecked === true) {
      selected.push({
        id: d.id,
        value: d.value,
        label: d.label
      });
    }
  });
}


  function sortDisplay() {
    if (displayType === '') {
      // sort by first name last name status
      return (
        <React.Fragment>
          <span className="margin-left-10">|</span>
          <DropdownMenuPrimitive.Root>
            <DropdownMenuPrimitive.Trigger asChild>
              <button 
                className='dropdown_bg button-secondary button-xsm text-small no-margin margin-left-10 align-center js-status-button'
                data-test="sort-dropdown">
                {load()}
                <span style={{ marginLeft: '0.5em' }}>▼</span>
              </button>
            </DropdownMenuPrimitive.Trigger>
            
            <DropdownMenuPrimitive.Portal>
              <DropdownMenuPrimitive.Content 
                className="dropdown-content"
                sideOffset={5}
                align="start">
                <DropdownMenuPrimitive.Item 
                  className="dropdown-item"
                  onClick={changeSortParam}
                  id="sortLastName">
                  Last Name
                </DropdownMenuPrimitive.Item>
                
                <DropdownMenuPrimitive.Item 
                  className="dropdown-item"
                  onClick={changeSortParam}
                  id="sortFirstName">
                  First Name
                </DropdownMenuPrimitive.Item>
                
                <DropdownMenuPrimitive.Sub>
                  <DropdownMenuPrimitive.SubTrigger className="dropdown-item dropdown-submenu-trigger">
                    Status
                    <span style={{ marginLeft: 'auto' }}>▶</span>
                  </DropdownMenuPrimitive.SubTrigger>
                  
                  <DropdownMenuPrimitive.Portal>
                    <DropdownMenuPrimitive.SubContent 
                      className="dropdown-content"
                      sideOffset={2}
                      alignOffset={-5}>
                      <div className="dropdown-checkbox-item" onClick={(e) => e.stopPropagation()}>
                        <input 
                          type="checkbox"
                          className="margin-10"
                          value='All' 
                          checked={!check.some((status) => status?.isChecked !== true)}
                          onChange={(e) => { e.stopPropagation(); handleSelect(e); }}
                        />
                        <label>All</label>
                      </div>
                      
                      {check && check.map(d => (
                        <div className="dropdown-checkbox-item" key={d.id} onClick={(e) => e.stopPropagation()}>
                          <input 
                            id={d.id} 
                            type="checkbox" 
                            value={d.value} 
                            checked={d.isChecked === true} 
                            onChange={(e) => { e.stopPropagation(); handleSelect(e); }} 
                            className="margin-10"
                          />
                          <label>{d.value}</label>
                        </div>
                      ))}
                    </DropdownMenuPrimitive.SubContent>
                  </DropdownMenuPrimitive.Portal>
                </DropdownMenuPrimitive.Sub>
              </DropdownMenuPrimitive.Content>
            </DropdownMenuPrimitive.Portal>
          </DropdownMenuPrimitive.Root>
          <Button
            data-test="sort-order-button"
            onClick={toggleSortOrder}
            buttonType={buttonTypes.secondary}
            buttonSize={buttonSizes.extraSmall}
            buttonTextSize={buttonTextSizes.small}
            text={sortOrderText}
            additionalStyles="no-margin margin-left-10 align-center js-sort-order-button"
            rightIconStyle={
              sortOrder !== 'az'
                ? 'align-center margin-left-5'
                : 'rotate-180-cw  align-center margin-left-5'
            }
            rightIcon={<DownArrowIcon />}
          />
        </React.Fragment>
      );
    } else {
      return '';
    }
  }

  /**
   * Function to set the search value for active filtering for users
   * @param {object} event - The event from typing in the value to the search bar
   * @fires setUsersFilter - Updates local state with the value typed into the search bar
   */
  const usersSearchFilter = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    restoreUsersSearchFocusOnNav = document.activeElement === event.target;
    
    if (searchDebounce.current) {
      clearTimeout(searchDebounce.current);
    }
    
    searchDebounce.current = setTimeout(() => {
      const newSearchParams = new URLSearchParams(search);
      const filteredUserCount = getFilteredUsersCount(value);
      if (value) {
        if (newSearchParams.get('search')) {
          newSearchParams.set('search', value);
        } else {
          newSearchParams.append('search', value);
        }
      } else {
        newSearchParams.delete('search');
      }
      const pagerValues = { ...display };
      pagerValues.totalLength = filteredUserCount;
      pagerValues.startValue = 0;
      const pagerString = `${pagerValues.totalLength}-${pagerValues.startValue}-${pagerValues.incrementValue}`;
      if (newSearchParams.get('display')) {
        newSearchParams.set('display', pagerString);
      } else {
        newSearchParams.append('display', pagerString);
      }
      navigate({
        pathname: location.pathname,
        search: newSearchParams.toString(),
      }, { replace: true });
    }, 500);
  };

  return (
    <div className="users-container">
      <FormattedMessage
        id="users.browserTabInfo"
        defaultMessage="Users | SARA"
        description="Done button">
        {(txt) => (
          <Helmet>
            <title>{txt}</title>
          </Helmet>
        )}
      </FormattedMessage>
      <div className="users-list__header">
        <FormattedMessage
          id="users.pageTitle"
          defaultMessage="Users"
          description="Users page title">
          {(txt) => <h1 className="no-margin">{txt}</h1>}
        </FormattedMessage>
        {showActive === false || showActive === 'false' ? (
          <div
            className="align-center background-alert padding-5"
            data-test="archive-alert-box">
            <strong>
              <FormattedMessage
                id="users.archivedUsersViewText"
                defaultMessage=" You are viewing archived users. To view active users click here:"
                description="Button for adding a new user"
              />
            </strong>
            <Button
              data-test="display-active"
              onClick={toggleShowArchived}
              buttonType={buttonTypes.success}
              buttonSize={buttonSizes.extraSmall}
              buttonTextSize={buttonTextSizes.small}
              text={activeUsersButton}
              additionalStyles="no-margin margin-left-10 js-display-active-alert-button"
            />
          </div>
        ) : (
          ''
        )}
        <div className="flex-align-stretch js-quick-actions-menu-container">
          <DropdownMenu
            data-test="quick-actions-menu"
            buttonStyles="link no-margin padding-10 margin-right-10 js-quick-actions-menu"
            menuButton={
              <React.Fragment>
                <FormattedMessage
                  id="users.utilitiesText"
                  defaultMessage="Utilities"
                  description="Button for adding a new user"
                />
                <SvgGear
                  height="15px"
                  width="15px"
                  className="margin-5 pointer-none"
                />
              </React.Fragment>
            }>
            <DropdownMenuItem>
              <Button
                data-test="display-archive"
                onClick={toggleShowArchived}
                buttonType={buttonTypes.noButton}
                buttonSize={buttonSizes.extraSmall}
                buttonTextSize={buttonTextSizes.small}
                text={!showActive ? activeUsersButton : archivedUsersButton}
                additionalStyles={
                  showActive === false || showActive === 'false'
                    ? 'no-margin js-display-active-button'
                    : 'no-margin js-display-archive'
                }
              />
            </DropdownMenuItem>
            <AccessControl
              data-test="access-control"
              feature={permissions.static.users.exportUsers}>
              <DropdownMenuItem>
                <Link
                  data-test="export-users-link"
                  className="dropdown-menu__menu-content-item"
                  to={'export'}
                  state={{
                    modal: true,
                    previous: currentLocation,
                  }}>
                  <FormattedMessage
                    id="users.exportUsersText"
                    defaultMessage="Export Users"
                    description="Opens editing something"
                  />
                </Link>
              </DropdownMenuItem>
            </AccessControl>
            <AccessControl
              data-test="access-control"
              feature={permissions.static.users.importUsers}>
              <DropdownMenuItem>
                <Link
                  data-test="import-users-link"
                  className="dropdown-menu__menu-content-item"
                  to={'import'}
                  state={{
                    modal: true,
                    previous: currentLocation,
                  }}>
                  <FormattedMessage
                    id="users.importUsersText"
                    defaultMessage="Import Users"
                    description="Opens editing something"
                  />
                </Link>
              </DropdownMenuItem>
            </AccessControl>
          </DropdownMenu>

          <AccessControl
            data-test="access-control"
            feature={permissions.static.users.addUser}>
            <Link
              className="link link-deep-blue no-margin padding-10"
              data-test="add-user-link"
              to={'addUser'}
              state={{
                modal: true,
                previous: currentLocation,
              }}>
              <span />
              <FormattedMessage
                id="users.addUserLinkText"
                defaultMessage="Add New User"
                description="Button for adding a new user"
              />
              <SvgXIcon className="rotate-45-cw margin-left-15" />
            </Link>
          </AccessControl>
        </div>
      </div>
      <div className="users-list__filter">
        <Link
          data-test="button-card-view"
          className="filter-bar__icon-button js-button-card-view text-extra-large flex-column flex-around margin-left-10"
          to="">
          <CardView is_active={displayType === '' ? false : true} />
        </Link>
        <Link
          data-test="button-row-view"
          className="filter-bar__icon-button js-button-row-view text-extra-large flex-column flex-around margin-left-10"
          to={'?view=table'}>
          <RowView is_active={displayType === 'table' ? false : true} />
        </Link>

        <label
          className="text-medium text-bold margin-left-10"
          htmlFor="usersFilter">
          {searchText}:
        </label>
        <input
          type="text"
          id="usersFilter"
          ref={searchInputRef}
          onChange={usersSearchFilter}
          className="message-table__filter-search-box margin-left-10"
          value={searchValue}
        />
        <Button
          id="isStaff"
          buttonType={buttonTypes.secondary}
          buttonSize={buttonSizes.extraSmall}
          buttonTextSize={buttonTextSizes.small}
          additionalStyles="js-staff-button"
          text={
            <FormattedMessage
              id="users.staffText"
              defaultMessage="Staff"
              description="Button for adding a new user"
            />
          }
          onClick={toggleShowStaff}
          rightIcon={
            showStaff === true || showStaff === 'true' ? (
              <React.Fragment>
                <span
                  className="js-staff-button-checkmark"
                  style={{ width: '0.5em' }}></span>
                <SvgCheckMarkIcon />
              </React.Fragment>
            ) : (
              <span
                className="js-staff-button-checkmark-spacer"
                style={{ width: '1.5em' }}></span>
            )
          }
          rightIconStyle="align-center margin-10-left "
        />
        <Button
          id="isNotStaff"
          buttonType={buttonTypes.secondary}
          buttonSize={buttonSizes.extraSmall}
          buttonTextSize={buttonTextSizes.small}
          additionalStyles="no-margin margin-left-10 align-center js-non-staff-button"
          text={
            <FormattedMessage
              id="users.nonStaffText"
              defaultMessage="Not Staff"
              description="Button for adding a new user"
            />
          }
          onClick={toggleShowNonStaff}
          rightIcon={
            showNonStaff === true || showNonStaff === 'true' ? (
              <React.Fragment>
                <span
                  className="js-non-staff-button-checkmark"
                  style={{ width: '0.5em' }}></span>
                <SvgCheckMarkIcon />
              </React.Fragment>
            ) : (
              <span
                className="js-non-staff-button-checkmark-spacer"
                style={{ width: '1.5em' }}></span>
            )
          }
          rightIconStyle="align-center margin-10-left "
        />

        {sortDisplay()}
        <Button
          onClick={resetFilters}
          buttonType={buttonTypes.secondary}
          buttonSize={buttonSizes.extraSmall}
          buttonTextSize={buttonTextSizes.small}
          text={resetText}
          additionalStyles="no-margin margin-left-10 js-reset-button"
        />
        <select
          id="displaySelect"
          onChange={changeIncrementValue}
          value={display.incrementValue}
          className="margin-left-10">
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={250}>250</option>
          <option value={500}>500</option>
        </select>
      </div>
      <Pager
        totalLength={display.totalLength}
        startValue={display.startValue}
        incrementValue={display.incrementValue}
        onClick={setPager}
      />
      {usersDisplay()}
      <Pager
        totalLength={display.totalLength}
        startValue={display.startValue}
        incrementValue={display.incrementValue}
        onClick={setPager}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  const usersArray = Object.values(state.users.users);
  return {
    usersArray,
    apiSpinner: state.ui.apiSpinner,
    userStatuses: state.users.userStatuses,
    unitsObj: state.units.units,
  };
};

export default connect(mapStateToProps)(UnconnectedUserList);
